import { LicenseJobQualification } from "common/models";
import { Qualification } from "common/models/QualificationCategoryType";
import * as React from "react";

interface LicenseJobQualificationListProps {
    licenseJobQualifications: LicenseJobQualification[]
}

export const LicenseJobQualificationList: React.FC<LicenseJobQualificationListProps> = (props: LicenseJobQualificationListProps) => {
    const { licenseJobQualifications } = props;
  
    const getLicenseJobQualifications = (licenseJobQualification: LicenseJobQualification) => {
        
        let anyOfAllOf = "";
        if(licenseJobQualification.license_choices.length > 1 
            && Qualification.fromId(licenseJobQualification.qualification_id)?.isLicenseAllOf()){
            anyOfAllOf = "ALL of the following valid licenses/certifications:";
        }
        else if(licenseJobQualification.license_choices.length > 1){
            anyOfAllOf = "ANY of the following valid licenses/certifications:";
        }

        if (licenseJobQualification.license_choices.length > 1) {
            return (
              <>
                {anyOfAllOf}
                <ul className="c-quals-child-list">
                  {licenseJobQualification.license_choices.map((choice) => (
                    <li style={{padding: 0}} key={choice.license_choice_id} className="c-job-detail__li">
                      {choice.license_choice_text}{" "}
                      {choice.state_tag_name ? `in ${choice.state_tag_name}` : ""}
                    </li>
                  ))}
                </ul>
              </>
            );
          }
        else{
            return (
                <>
                {`Valid ${licenseJobQualification.license_choices[0].license_choice_text} certification/license${
                  licenseJobQualification.license_choices[0].state_tag_name
                    ? ` in the state of ${licenseJobQualification.license_choices[0].state_tag_name}`
                    : ""
                }`}
              </>
            );
        }

    };
       
    return (
        <React.Fragment>
          {licenseJobQualifications.map(licenseJobQualification => (
            <li style={{padding: 0}} key={`${licenseJobQualification.job_qualification_id}`}>
              {getLicenseJobQualifications(licenseJobQualification)}
            </li>
          ))}
        </React.Fragment>
      );
  }


export default LicenseJobQualificationList;
